export function paginatedListingsQuery(params) {

    return JSON.stringify({
        query: `
            query Listings(
                $categories: [ID],
                $exclude_categories: [ID],
                $places: [ID],
                $facets: [ID],
                $tags: [ID],
                $grades: [ID],
                $alerts: [ID],
                $keywords: String,
                $distance: [ID],
                $listingType: String,
                $startDate: String,
                $endDate: String,
                $radius: Int,
                $offset: Int,
                $limit: Int,
                $exclude: Int,
                $customSort: String,
                $seed: String,
                $sortBy: ListingSortFields,
                $featured: Boolean,
                $bounds: MapBoundsInput,
                $imageWidth: Float,
                $imageHeight: Float,
                $mapIconExtraClasses: String,
            ) {
                paginatedListings(
                    categories: $categories
                    exclude_categories: $exclude_categories
                    places: $places
                    tags: $tags
                    facetOptions: $facets
                    grades: $grades
                    alerts: $alerts
                    listingType: $listingType
                    startDate: $startDate
                    endDate: $endDate
                    radius: $radius
                    keywords: $keywords
                    distance: $distance
                    offset: $offset
                    limit: $limit
                    exclude: $exclude
                    customSort: $customSort
                    seed: $seed
                    sort: $sortBy
                    featured: $featured
                    bounds: $bounds
                )  {
                    edges {
                        node {
                            id
                            name
                            lastEdited
                            type
                            featured
                            urlSlug
                            limitedSummary
                            identifier
                            mapIconPath
                            mapIconWidth
                            mapIconHeight
                            website
                            phone
                            email
                            minPrice
                            maxPrice
                            bookingURL
                            latitude
                            longitude
                            street
                            suburb
                            city {
                                name
                            }
                            image {
                                absoluteURL
                                urlForList: resized(
                                    width: $imageWidth
                                    height: $imageHeight
                                )
                                __typename
                            }
                            mainCategory {
                                id
                                title
                                mapIconSvg(
                                    extraClasses: $mapIconExtraClasses
                                )
                            }
                            categories {
                                id
                                title
                                __typename
                            }
                            ... on Event {
                                currentStartDate
                                niceCurrentStartDate
                                niceStartDate
                                niceEndDate
                                venue
                                multipleOccurrences
                                futureOccurrences: currentAndFutureOccurrences {
                                    currentStartDateNice
                                    startDateNice
                                    startDate(format: CUSTOM, customFormat: "MMM d")
                                    startTimeNice
                                    endDateNice
                                    endTimeNice
                                    endDate(format: CUSTOM, customFormat: "MMM d")
                                    multiDays
                                    __typename
                                }
                                __typename
                            }
                            ... on Track {
                                distance
                                duration
                                trackGrade
                                trackGradeName
                                trackAlerts {
                                    name
                                    description
                                    __typename
                                }
                                trackFileJson
                                trackFileExtension
                                trackCreditText
                                trackCreditSource
                                __typename
                            }
                            __typename
                        }
                        __typename
                    }
                    pageInfo {
                        hasNextPage
                        hasPreviousPage
                        totalCount
                        __typename
                    }
                    __typename
                }
            }
        `,
        variables: params,
    });

}
